import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

const maskCep = (v) => (v || "").replace(/\D/g, "").slice(0, 8).replace(/(\d{5})(\d)/, "$1-$2");

export default function AddressFields({ value, onChange, idPrefix = "addr" }) {
  const [loading, setLoading] = useState(false);
  const set = (k, v) => onChange({ ...value, [k]: v });

  const lookupCep = async (raw) => {
    const digits = (raw || "").replace(/\D/g, "");
    if (digits.length !== 8) return;
    setLoading(true);
    try {
      const res = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
      const data = await res.json();
      if (!data.erro) {
        onChange({
          ...value, cep: raw,
          street: data.logradouro || value.street || "",
          neighborhood: data.bairro || value.neighborhood || "",
          city: data.localidade || value.city || "",
          state: data.uf || value.state || "",
        });
      }
    } catch (e) {
      console.error("CEP lookup failed", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-3" data-testid={`${idPrefix}-fields`}>
      <div className="grid grid-cols-2 gap-2">
        <div className="space-y-1.5">
          <Label className="flex items-center gap-1">CEP * {loading && <Loader2 className="h-3 w-3 animate-spin" />}</Label>
          <Input value={value.cep || ""} placeholder="00000-000" data-testid={`${idPrefix}-cep-input`}
            onChange={(e) => { const m = maskCep(e.target.value); set("cep", m); if (m.replace(/\D/g, "").length === 8) lookupCep(m); }} />
        </div>
        <div className="space-y-1.5"><Label>Número</Label>
          <Input value={value.number || ""} onChange={(e) => set("number", e.target.value)} data-testid={`${idPrefix}-number-input`} /></div>
      </div>
      <div className="space-y-1.5"><Label>Rua / Logradouro *</Label>
        <Input value={value.street || ""} onChange={(e) => set("street", e.target.value)} placeholder="Rua, avenida..." data-testid={`${idPrefix}-street-input`} /></div>
      <div className="grid grid-cols-2 gap-2">
        <div className="space-y-1.5"><Label>Complemento</Label>
          <Input value={value.complement || ""} onChange={(e) => set("complement", e.target.value)} placeholder="Apto, bloco..." data-testid={`${idPrefix}-complement-input`} /></div>
        <div className="space-y-1.5"><Label>Bairro</Label>
          <Input value={value.neighborhood || ""} onChange={(e) => set("neighborhood", e.target.value)} data-testid={`${idPrefix}-neighborhood-input`} /></div>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <div className="col-span-2 space-y-1.5"><Label>Cidade *</Label>
          <Input value={value.city || ""} onChange={(e) => set("city", e.target.value)} data-testid={`${idPrefix}-city-input`} /></div>
        <div className="space-y-1.5"><Label>UF *</Label>
          <Input value={value.state || ""} maxLength={2} onChange={(e) => set("state", e.target.value.toUpperCase())} placeholder="RJ" data-testid={`${idPrefix}-state-input`} /></div>
      </div>
    </div>
  );
}

export function isAddressComplete(a) {
  return !!(a && (a.cep || "").replace(/\D/g, "").length === 8 && (a.street || "").trim() && (a.city || "").trim() && (a.state || "").trim());
}
